if(!customElements.get("collection-load-previous")){
  class CollectionLoadPrevious extends HTMLElement {
    constructor(){
      super(),
      this.btnLoadPrevious = this.querySelector(".js-btn-load-previous"),
      this.productGrid = document.querySelector("#product-grid"),
      this.setProperties(),
      this.btnLoadPrevious.addEventListener("click", e=>{
        e.preventDefault(),
        this.btnLoadPrevious.setAttribute("disabled",!0),
        this.loadPreviousProducts()
      }),
      this.checkPageParameter()
    }

    checkPageParameter(){
      const page = new URLSearchParams(window.location.search).get("page") || "1",
            previousButton = document.querySelector("collection-load-previous");
      page === "1" && previousButton && (previousButton.style.display = "none")
    }

    setProperties(){
      this.productGrid = document.querySelector("#product-grid"),
      this.btnLoadPrevious = this.querySelector(".js-btn-load-previous")
    }

    async loadPreviousProducts(){
      try {
        const prevPageText = await (await fetch(`${this.btnLoadPrevious.dataset.href}`)).text(),
              prevPageHTML = new DOMParser().parseFromString(prevPageText,"text/html"),
              productGrid = prevPageHTML.querySelector("#ProductGridContainer").querySelector("#product-grid");

        this.productGrid.insertAdjacentHTML("afterbegin", productGrid.innerHTML);

        // --- Swym re-init: Ensure wishlist buttons attach to newly loaded products ---
        if(window.SwymCallbacks){
          window.SwymCallbacks.push(function(swat){
            swat.initializeActionButtons("body");
          });
        }
        // --- End Swym re-init ---

        const prevButtonOnNewPage = prevPageHTML.querySelector(".js-btn-load-previous");
        if(prevButtonOnNewPage){
          const prevPageLink = prevButtonOnNewPage.dataset.href;
          this.btnLoadPrevious.dataset.href = prevPageLink
        }

        const currentUrl = new URL(window.location.href),
              currentUrlParams = new URLSearchParams(currentUrl.search),
              currentPage = parseInt(currentUrlParams.get("page"),10) || 1;
        currentUrlParams.set("page", currentPage-1),
        currentUrl.search = currentUrlParams.toString(),
        history.replaceState({}, "", currentUrl.toString()),
        this.checkPageParameter()

      } catch(error){
        console.error(error),
        alert(error.message)
      } finally {
        this.btnLoadPrevious.removeAttribute("disabled")
      }
    }
  }
  customElements.define("collection-load-previous", CollectionLoadPrevious)
}
//# sourceMappingURL=/s/files/1/0735/4640/0010/t/12/assets/collection-load-previous.js.map?v=1732693193
